import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { BLOG_CATEGORIES } from "@/lib/constants";

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("all");

  useEffect(() => {
    const params = {};
    if (q) params.q = q;
    if (category !== "all") params.category = category;
    api.get("/blogs", { params }).then((r) => setBlogs(r.data));
  }, [q, category]);

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16" data-testid="blogs-page">
      <div className="font-mono text-xs uppercase tracking-[0.3em] brand-orange mb-4">// The Journal</div>
      <h1 className="font-display text-5xl md:text-7xl font-black uppercase leading-none tracking-tighter">
        Stories, drills &<br /><span className="brand-blue">match reports.</span>
      </h1>

      <div className="mt-10 flex flex-col md:flex-row gap-4 md:items-center">
        <div className="relative flex-1 max-w-md">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
          <input
            data-testid="blog-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search articles…"
            className="w-full bg-[#131A2B] border border-white/12 pl-10 pr-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-brand-orange"
          />
        </div>
        <div className="flex gap-2 flex-wrap">
          {BLOG_CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`blog-cat-${c}`}
              onClick={() => setCategory(c)}
              className={`px-4 py-2 font-mono text-xs uppercase tracking-widest border transition-all ${
                category === c ? "bg-brand-blue text-white border-brand-blue" : "border-white/20 text-white/70 hover:border-white/50"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {blogs.map((b) => (
          <Link
            to={`/blogs/${b.slug}`}
            key={b.id}
            data-testid={`blog-card-${b.slug}`}
            className="group bg-[#131A2B] border border-white/12 hover-lift overflow-hidden"
          >
            <div className="aspect-video overflow-hidden">
              <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-6">
              <div className="font-mono text-[10px] uppercase tracking-widest brand-orange">{b.category}</div>
              <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-tight mt-3">{b.title}</h3>
              <p className="text-white/60 text-sm mt-3 line-clamp-2">{b.excerpt}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs font-mono text-white/40">By {b.author}</span>
                <ArrowRight size={16} className="brand-blue group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        ))}
      </div>
      {blogs.length === 0 && (
        <div className="text-center py-24 text-white/40 font-mono uppercase tracking-widest">No articles match your search.</div>
      )}
    </div>
  );
}
